<template>
  <hm-col v-if="!isEmpty(paymentStatus)" :id="$attrs['id']" :grid="true" cols="12">
    <hm-col cols="12 6@tablet 8@desktop" style="position: relative;" class="align-content-center">
      <div class="payment-status">
        <label-value-dotted :value="paymentStatus.totalChargeAmount | toCurrency" :unit="hotelSettings.details.currency" :label="$t('util.paymentStatus.totalChargeAmount')" />
        <label-value-dotted :value="paymentStatus.totalPaymentAmount | toCurrency" :unit="hotelSettings.details.currency" :label="$t('util.paymentStatus.totalPaymentAmount')" />
        <label-value-dotted :value-class="[{'color--red': paymentStatus.balance < 0}]"
                            :value="paymentStatus.balance | toCurrency"
                            :unit="hotelSettings.details.currency"
                            :label="$t('util.paymentStatus.balance')"
                            class="label-value-dotted__wrapper--sum label-value-dotted__wrapper--bold" />
        <div v-if="(paymentStatus.folioWithOpenBalance || paymentStatus.balance !== 0) && !paymentStatus.folioWithNonPrepaymentOpenBalance" class="payment-status__info">
          <span>{{ $t('util.paymentStatus.hintOneFolioHasOpenDeposit') }}</span>
        </div>
        <div v-else-if="paymentStatus.balance !== 0" class="payment-status__notification">
          <span>{{ $t('util.paymentStatus.hintOneFolioHasOpenBalance') }}</span>
        </div>
        <div v-else-if="paymentStatus.balance === 0 && (paymentStatus.folioWithOpenBalance || paymentStatus.openFolios)" class="payment-status__notification">
          <span>{{ $t('util.paymentStatus.hintOneFolioHasOpenBalance') }}</span>
        </div>
        <!--
        <hm-button v-if="!isEmpty(route)"
                   class="btn--orange btn--no-margin-bottom"
                   cols="12"
                   icon-left="cash"
                   @click="routeToInvoices">Rechnungen</hm-button>
                   -->
      </div>
    </hm-col>

    <template v-if="!empty && paymentStatus.folioWithOpenBalance === false && paymentStatus.openFolios === false && paymentStatus.balance === 0">
      <hm-col cols="12 6@tablet 4@desktop" style="position: relative;text-align:center;">
        <i class="fal fa-check fa-w-14 fa-9x color--mint"></i>
      </hm-col>
    </template>
    <template v-else-if="!empty && paymentStatus.balance === 0 && (paymentStatus.folioWithOpenBalance || paymentStatus.openFolios)">
      <hm-col cols="12 6@tablet 4@desktop" style="position: relative;text-align:center;">
        <i class="fal fa-exclamation-triangle fa-w-14 fa-9x color--warn"></i>
      </hm-col>
    </template>
    <template v-else>
      <hm-col cols="12 6@tablet 4@desktop" style="position: relative;">
        <div class="chart__wrapper__wrapper">
          <div class="chart__wrapper">
            <GChart ref="chart"
                    :data="[ [$t('util.paymentStatus.chart.status'), $t('util.paymentStatus.chart.amount')], [$t('util.paymentStatus.chart.paid'), chartPaymentStatus.totalPaymentAmount], [$t('util.paymentStatus.chart.open'), chartPaymentStatus.balance] ]"
                    :options="{ pieHole: 0.8, slices: { 0: { color: '#2da295' }, 1: {color: '#BADCD8' } }, legend: 'none', enableInteractivity: false, pieSliceText: 'none', fontName: 'Nunito Sans', fontSize: '14', pieSliceText: 'none', tooltip: { trigger: 'none', ignoreBounds: true }, chartArea:{left:'5%',top:'5%',right:'5%',bottom:'5%',width:'90%',height:'200px'}, highlightOnMouseOver: false }"
                    :settings="{ packages: ['corechart', 'table', 'map'] }"
                    :resize-debounce="250"
                    type="PieChart" />
          </div>
          <div class="chart__info">
            <span class="chart__percent" v-html="`${chartPaymentStatus.paidPercentage}%`"></span><br>
            <span>{{ $t('util.paymentStatus.chart.labelPaid') }}</span>
          </div>
        </div>
      </hm-col>
    </template>
  </hm-col>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { clone, isNil, startsWith } from 'lodash';

export default {
  name: 'PaymentStatus',

  mixins: [HotelmeisterMixin],

  props: {
    title: {
      required: false,
      type: String,
      default: 'Zahlungsstatus',
    },
    route: {
      required: false,
      type: String,
      default: null,
    },
    routeParams: {
      required: false,
      type: Object,
      default: () => ({}),
    },
    paymentStatus: {
      required: true,
      type: Object,
      default: () => ({
        balance: 0,
        folioWithOpenBalance: false,
      }),
    },
  },

  data() {
    return {
    };
  },

  computed: {
    empty: function () {
      return this.paymentStatus.paidPercentage === 0
        && this.paymentStatus.totalChargeAmount === 0
        && this.paymentStatus.totalPaymentAmount === 0
        && this.paymentStatus.balance === 0
        && this.paymentStatus.folioWithOpenBalance === false
        && this.paymentStatus.openFolios === false;
    },
    chartPaymentStatus: function () {
      const chartPaymentStatus = clone(this.paymentStatus);
      if (!isNil(chartPaymentStatus)) {
        chartPaymentStatus.balance *= -1;
        chartPaymentStatus.balance = chartPaymentStatus.balance >= 0 ? chartPaymentStatus.balance : 0;
        chartPaymentStatus.totalPaymentAmount = chartPaymentStatus.totalPaymentAmount >= 0 ? chartPaymentStatus.totalPaymentAmount : 0;

        if (chartPaymentStatus.balance === 0 && chartPaymentStatus.totalPaymentAmount === 0) {
          chartPaymentStatus.balance = 1;
        }
      }

      return chartPaymentStatus;
    },
  },

  methods: {
    updateChart() {
      if (!isNil(this.$refs) && !isNil(this.$refs.chart)) {
        this.$refs.chart.drawChart();
      }
    },
    routeToInvoices() {
      if (!isNil(this.route)) {
        this.$router.push(
          {
            name: this.route,
            params: {
              ...this.routeParams,
            },
          },
        );
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-icon {
    display: grid;
  }


  .payment-status {
    &__notification {
      color: $error;
      font-size: 1.1rem;
    }
    &__info {
      color: $orange;
      font-size: 1.1rem;
    }
  }

  .chart__wrapper__wrapper {
    position: relative;
    height: 0;
    // padding-bottom: 100%;
    padding-bottom: 200px;
    overflow: hidden;

    .chart__wrapper {
      position: relative;
      top: 0;
      // margin-top: calc((100% - 200px) / 2);
      margin-top: 0;
    }
    .chart__info {
      position: absolute;
      top: 50%;
      left: 50%;
      top: 100px;
      transform: translate(-50%,-50%);
      text-align:center;
    }
    .chart__percent {
      font-size: 3rem;
      font-weight:bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/PaymentStatus.vue